import {
  GameLiveConnectionMethod as BaseGameLiveConnectionMethod
} from '@pascal/pascal-core/shared/core/services/liveConnection/types';

export const GameLiveConnectionMethod = Object.assign({
  DoSpin: 'DoSpin',
  CashOut: 'Cashout',
  ReportState: 'ReportState',
  CashOutResult: 'CashoutResult',
  ResultReportResult: 'ReportStateResult',
  DoSpinResult: 'DoSpinResult',
  Reconnecting: 'Reconnecting',
  PreBonusReportState: 'PreBonusReportState',
  PreBonusReportStateResult: 'PreBonusReportStateResult',
  BonusReportState: 'BonusReportState',
  BonusReportStateResult: 'BonusReportStateResult',
  GameOpen: 'GameOpen',
}, BaseGameLiveConnectionMethod);
